// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

/** The parts of an `ApiError` that carry an IAM refusal. */
interface RefusalLike {
  status?: number;
  code?: string;
  upstreamMessage?: string;
}

/**
 * IAM's reason for refusing a change (e.g. `OWN_ORG_ADMIN_REMOVAL`,
 * `LAST_ORG_ADMIN`, `ORG_ADMIN_ORGANIZATION_ONLY`), written to be shown to the
 * admin as-is (AB#35966), or null when the error isn't such a refusal.
 */
export function iamRefusalMessage(error: unknown): string | null {
  if (!error || typeof error !== 'object') return null;
  const { status, code, upstreamMessage } = error as RefusalLike;
  if (typeof status !== 'number' || status < 400 || status >= 500) return null;
  return code && upstreamMessage ? upstreamMessage : null;
}
